import { YAxisProps } from 'recharts'

import { GraphDataType } from '@src/Application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'

export const getMobileData = (graphData: GraphDataType[]): GraphDataType[] => {
    const numberOfData = graphData.length
    const step = numberOfData / 5
    let mobileData = [graphData[0]]

    if (numberOfData > 7) {
        for (let i = 1; i <= 4; i++) {
            mobileData.push(graphData[Math.round(i * step)])
        }

        mobileData.push(graphData[graphData.length - 1])
    } else {
        mobileData = graphData.slice(0, Math.min(6, numberOfData))
    }

    return mobileData
}

export const getYAxisProps = (domainValueMin: Nullable<number>, domainValueMax: Nullable<number>): YAxisProps => {
    const yAxisProps: YAxisProps = {}

    if (domainValueMin && domainValueMax) {
        yAxisProps.domain = [domainValueMin, domainValueMax]
    }

    return yAxisProps
}
